// Error constants

export const ERROR_MSG_400 = 'Bad Request, Please contact support.';
export const ERROR_MSG_500 = 'Something went wrong, Please try again later.';
export const SERVER_ERROR = 'An unexpected error occurred. Please try again.';
export const NETWORK_ERROR = 'Network error. Please check your connection.';
